import { Component, OnInit } from '@angular/core';
import { CaseLog } from '../../_types/case-log';
import { ComunicationsComponent } from 'src/app/modules/comunications/communications/comunications.component';
import { TransactionsTypesService } from 'src/app/modules/transactions/_services/transactions-types.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CaseFile, CaseServiceFilesPDFRequestDTO, CaseServiceFilesRequestDTO } from '../../_types/case-file';
import { TemplatesService } from 'src/app/modules/templates/_services/templates.service';
import { CasesService } from '../../_services/cases.service';
import { MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { CaseExpert } from '../../_types/case-expert';
import { AuditService } from 'src/app/core/services/audit.service';
import { AuditEvents } from 'src/app/core/_types/audit-events';
import { CaseService } from '../../_types/case-service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CasesExpertsService } from '../../_services/cases-experts.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesFilesService } from '../../_services/cases-files.service';
import { Case } from '../../_types/case';
import { File } from '../../../common/_types/file'
import { environment } from 'src/environment/environment';


@Component({
    selector: 'app-photo-report',
    templateUrl: './photo-report.component.html',
    styleUrls: ['./photo-report.component.css'],
    standalone: false
})
export class PhotoReportComponent implements OnInit {

  public displayFramePhoto: boolean = false;
  public photoInfo: any = {num_images: 4,landscape: false, logo: true, code: true, has_description_images:true };
  public arrayYesNo: any = [{id: false, name: "No" },{id: true, name: "Sí" }];
  public arrayYesNoLandscape:  any = [{id: false, name: "Vertical" },{id: true, name: "Horizontal" }];
  public numberPages: any = [{id: 4, name: "4" },{id: 6, name: "6" }];
  public caseFilesIdToPDF:  any[] = [];
  public caseFilesIdToPDFChecked: { [key: string]: any[] } = {};
  public photoInfoMail: any = {thirdPartyType: 'caseExpert',landscape: false, logo: true, code: true, has_description_images:true };
  public thirdPartyOptions : any = [{id: "company", name: "Compañia" }, {id: "caseExpert", name: "Perito" },{id: "worker", name: "Operario" },{id: "other", name: "Otros" }];
  public thirdParties: any[] = [];
  public thirdPartiesSendEmail:any= {email: ""};
  public filesIdsToSend: string[] = [];
  public filePhoto? : any;
  public loadingExperts: boolean = false;
  public caseExperts: CaseExpert[] = [];
  public caseServices: CaseService[] = [];
  public caseFiles: any[] = [];
  public caseFilesWithoutService: any[] = [];
  public caseFilesServices: any[] = [];
  public case: Case = new Case();
  public imagesUrl: string = environment.api_gw + 'common/files/';
  public counter: number = 1;
  public finalArrayFiles: any[] = [];
  constructor(
    private dialogService: DialogService, 
    private templateService: TemplatesService, 
    private casesService: CasesService,
    private messageService: MessageService,
    private filesService: FilesService,
    private casesExpertsService: CasesExpertsService, 
    private casesFilesService: CasesFilesService,
    private config: DynamicDialogConfig,
    private auditService: AuditService,
    private dynamicDialogRef: DynamicDialogRef) { }

  async ngOnInit() {    
    this.caseServices = this.config.data.caseServices;
    this.case = this.config.data.case;
    this.caseFilesServices = this.config.data.caseFilesServices;
    this.caseFilesWithoutService = this.config.data.caseFilesWithoutService;
    this.caseFiles = this.config.data.caseFiles;

    this.caseFiles = this.caseFiles.filter((m: any) => m.file.contentType.startsWith("image"));

    this.caseFilesWithoutService.forEach((caseFile: any) => {
      caseFile.index = this.counter;
      this.counter++;
    });
    this.caseFilesServices.forEach((service: any) => {
      var aux = this.filesByService(service.id);
      aux.forEach((caseFile: any) => {
        var caseFileFounded = this.caseFiles.find((m: any) => m.id == caseFile.id);
        if(caseFileFounded != null){
          caseFileFounded.index = this.counter;
          this.counter++;
        }
      });
    });

    this.finalArrayFiles = this.caseFilesWithoutService.concat(this.caseFiles);
    this.caseFilesIdToPDF = [];
  }

  async showFilesDocument(){
    if(this.caseFilesIdToPDF.length > 0){
      this.templateService.getTemplateId("VisitPhotos").then(async (result:any) => {
        if(result == null) return;
        
        var requestData = new CaseServiceFilesPDFRequestDTO();
        requestData.caseId = this.case.id;
        requestData.templateId = result.templateId;
        requestData.num_images = this.photoInfo.num_images;
        requestData.landscape = this.photoInfo.landscape;
        requestData.logo = this.photoInfo.logo;
        requestData.code = this.photoInfo.code;
        requestData.has_description_images = this.photoInfo.has_description_images;
        requestData.description = this.photoInfo.description;
        requestData.caseFilesIds = this.caseFilesIdToPDF;
        requestData.caseFiles = this.caseFilesIdToPDF.map((fileId: string) => {
          return {
            caseFileId: fileId,
            index: this.finalArrayFiles.find((m: any) => m.fileId == fileId) ? this.finalArrayFiles.find((m: any) => m.fileId == fileId).index : 0
          }
        });

        if(result.templateId != null){
          //la generación del informe no modifica nada en base de datos: la registra la interfaz
          this.auditService.track(AuditEvents.ATTACHMENT_PHOTO_REPORT, {
            entityType: 'case',
            entityId: this.case.id,
            metadata: { files: String(this.caseFilesIdToPDF.length) }
          });

          this.casesService.exportCasePhotos(requestData).then(result => {
            this.filePhoto = result;
            var fileURL = URL.createObjectURL(result);
            this.displayFramePhoto = true;
            setTimeout(() => {
              var iframe: any = document.getElementById("case-file-preview");              
              iframe.src = fileURL;
            });
          });
        }
      });
    }else{
      this.messageService.add({ closable: true, severity: 'error', detail:"Seleccione al menos una imagen para generar el documento" });
    }
  }

  async changeThirdParty(event: any){
    if(event.value == "company"){
      this.thirdPartiesSendEmail.email = this.case.company.email;
    }else if(event.value=="caseExpert"){
      await this.loadCaseExperts();
      this.thirdParties = this.caseExperts.map((caseExpert: CaseExpert) => {
        return {
          id: caseExpert.expert?.email,
          name: caseExpert.expert?.name
        }
      }).filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);;

    }else if(event.value=="worker"){
      this.thirdParties = this.caseServices.map((service: CaseService) => {
        return {
          id: service.worker?.email,
          name: service.worker?.name
        }
      }).filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);

    }else if(event.value="other"){

    }

  }

  async loadCaseExperts() {
      this.loadingExperts = true;
      let params: IParamsCollection = {
        include: ['expert']
      }
      let filters: any = {
        caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id),
      };
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.casesExpertsService.all(params));
      this.caseExperts = response.data;
      this.loadingExperts = false;
    }

  async selectThirdParty(event: any)
  {
    this.thirdPartiesSendEmail.email = event.value;
  }


  selectAll(event: any, id?: string | null ){
    this.caseFilesIdToPDFChecked[id??"empty"] = [];//para pintarlo el otro array para mandarlo.   
    if(event.checked){
      if(id != "" && id != null){
        var filesservices =  this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == id);
        filesservices.forEach((caseFile: CaseFile) => {
          this.caseFilesIdToPDFChecked[id].push(caseFile.fileId);
          this.caseFilesIdToPDF.push(caseFile.fileId);
        });
      }else{
        this.caseFilesWithoutService.forEach((caseFile: CaseFile) => {
          this.caseFilesIdToPDFChecked["empty"].push(caseFile.fileId);
          this.caseFilesIdToPDF.push(caseFile.fileId);
        });
      }
    }else{
      if(id != "" && id != null){
        var filesservices =  this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == id);
        filesservices.forEach((caseFile: CaseFile) => {
          //this.caseFilesIdToPDFChecked[id].splice( this.caseFilesIdToPDFChecked[id].findIndex((m: any) => m == caseFile.fileId), 1 ); No hace falta porque se vacia, pero eliminamo sel orot
          if(this.caseFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId) != -1) this.caseFilesIdToPDF.splice(this.caseFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId), 1 );
        });
      }else{
        this.caseFilesWithoutService.forEach((caseFile: CaseFile) => {
          if(this.caseFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId) != -1) this.caseFilesIdToPDF.splice(this.caseFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId), 1 );
        });
      }
    }
  }

  async selectFile(value: any, id: string | "empty"){
    if(this.caseFilesIdToPDF.findIndex((m: any) => m == value) == -1){
      this.caseFilesIdToPDF.push(value);
      this.caseFilesIdToPDFChecked[id].push(value);
    }else{
      if(this.caseFilesIdToPDF.findIndex((m: any) => m == value) != -1) this.caseFilesIdToPDF.splice(this.caseFilesIdToPDF.findIndex((m: any) => m == value), 1 );
      if(this.caseFilesIdToPDFChecked[id].findIndex((m: any) => m == value)!=-1) this.caseFilesIdToPDFChecked[id].splice(this.caseFilesIdToPDFChecked[id].findIndex((m: any) => m == value), 1 );
    }
  }

   async saveMailAndSend(){
    if(this.thirdPartiesSendEmail.email == "" || this.thirdPartiesSendEmail.email == null){

      this.messageService.add({ closable: true, severity: 'error', detail:"Seleccione el email al que enviar el correo" });
      return;
    }else{
       //Giuardamos el documento antes de enviarlo
       let data: File = new File();
       data.fileName = "Reporte fotográfico.";
       data.description = "Reporte fotográfico del expediente " + this.case.caseNumber;
       data.size = this.filePhoto?.size ?? 0;
       data.contentType = "application/pdf";
       //data.path = file.name;
      
       //creamos el file
       let fileResponse = await firstValueFrom(this.filesService.save(data));
       
      this.filePhoto.fileName = "info_fotografico_" + this.case.caseNumber + ".pdf";
      //subimos el fichero al file
      let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, this.filePhoto));
      
       this.filesIdsToSend.push(fileResponse.id as string);
      
       this.addComunication('Mail',this.thirdPartiesSendEmail.email, true);
    }
   
  }

  
  addComunication(comunicationType:string|null, email:string|null, attachment: boolean = false) {
    let ref = this.dialogService.open(ComunicationsComponent, {
      closable: true,
      modal: true,
      header: 'Enviar comunicación',
      width: '60%',
      data: {
        caseId: this.case.id,
        model: this.case,
        comunicationType: comunicationType,
        email: email,
        attachments: (attachment ? this.filesIdsToSend: []),
        subject: "Informe fotográfico expediente " + this.case.caseNumber,
        templateDestination: 'Case'
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.cancel();
    });
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
  fileIsAnImage(file: File) {
    return file.contentType.startsWith("image");
  }

  filesByService(serviceId: string) {
    return this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == serviceId);
  }

}
